export default __webpack_public_path__ + "static/media/LaneProductProgress.1c84437b.jpg";